import { useTranslation } from "react-i18next";

import { KnowledgeCheckListProps } from "@/features/certifications/participant-detail/types";
import { KNOWLEDGE_CHECK_STATES } from "@/domains/certifications/constants";

import "../styles.css";

const KnowledgeCheckList = ({ rows }: KnowledgeCheckListProps) => {
  const { t } = useTranslation();

  return (
    <section className="certification-card participant-detail-card flex flex-col gap-300">
      <h2 className="certification-heading body-m-medium">
        {t("certification.admin.participant.checksTitle")}
      </h2>

      <ul className="participant-detail-weeks flex flex-col">
        {rows.map(({ week, title, state, attempt }) => (
          <li
            key={week}
            className="participant-detail-week flex flex-wrap items-center justify-between gap-300"
          >
            <span className="body-s-medium">
              {t("certification.admin.participant.weekTitle", { week, title })}
            </span>

            <span
              className={`body-s-regular ${
                state === KNOWLEDGE_CHECK_STATES.PASSED
                  ? "participant-detail-done"
                  : state === KNOWLEDGE_CHECK_STATES.NOT_STARTED
                    ? "certification-muted"
                    : "participant-detail-open"
              }`}
            >
              {attempt && attempt.attemptCount > 0
                ? t(`certification.admin.participant.check.${state}`, {
                    count: attempt.attemptCount,
                    max: attempt.maxAttempts,
                  })
                : t("certification.admin.participant.check.notAttempted")}
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default KnowledgeCheckList;
